"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utility_1 = require("./utility");
const logger_1 = require("../logger");
class Writer {
    /**
     * Creates an instance of Writer.
     *
     * @param {WithWildcards<WriterOptions>} options Options for this writer
     */
    constructor(options) {
        this.source = options.source && utility_1.asArray(options.source);
        this.level = options.level || '';
        this.onLog = options.onLog;
        this.levelId = logger_1.getLevelId(this.level);
    }
    write(data, callback) {
        let result = true;
        if (this.onLog) {
            try {
                result = this.onLog(data) !== false;
            }
            catch (e) { }
        }
        if (typeof callback === 'function')
            callback();
        return result;
    }
}
exports.default = Writer;
//# sourceMappingURL=writer.js.map